import React from "react";
import { BsSearch } from "react-icons/bs";
import { FiX } from "react-icons/fi";
import SearchWrapper from "./SearchWrapper";

const Search = ({ Value, setValue, Placeholder }) => {
  const hasValue = Boolean(String(Value || "").trim());

  return (
    <SearchWrapper>
      <div className="flex items-center gap-2 w-full max-w-[360px] px-3 h-10 bg-white border border-line rounded-xl shadow-soft focus-within:border-main focus-within:ring-2 focus-within:ring-main/15 transition-all">
        <BsSearch className="text-muted text-[15px] shrink-0" aria-hidden="true" />
        <input
          type="search"
          aria-label={Placeholder || "Search table"}
          className="outline-none bg-transparent text-ink placeholder:text-muted w-full text-sm font-medium"
          placeholder={Placeholder}
          value={Value}
          onChange={(e) => setValue(e.target.value)}
        />
        {hasValue ? (
          <button
            type="button"
            aria-label="Clear search"
            onClick={() => setValue("")}
            className="shrink-0 inline-flex h-6 w-6 items-center justify-center rounded-md text-muted hover:bg-subtle hover:text-ink transition-colors"
          >
            <FiX size={14} />
          </button>
        ) : null}
      </div>
    </SearchWrapper>
  );
};

export default Search;
